module.exports = vendor_1267b340262337fbceca;